export default __webpack_public_path__ + "static/media/avatar_siti3.d25deac8.mp3";